import { Injectable } from "@angular/core";
import { APIService } from "./api.service";
import { Constants } from "../constants";
import * as moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { LocalDataService } from "./local-data.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private _APIService: APIService, private _localCookies: CookieService, 
    private _localDataService: LocalDataService, private router: Router,) { }
  searchByPhone(phone: string) {
    return this._APIService.post({ phoneNumber: phone }, Constants.API_URLS.searchByPhone);
  }
  getGeoCodeByAddress(address: string) {
    return this._APIService.post({ address: address }, Constants.API_URLS.getGeoCodeByAddress + address);
  }
  addressBuilder(preva: any, newa: any, isComReq = true) {
    newa = (newa == null ? "" : newa);
    if (preva != "") {
      if (newa != "") {
        preva += (isComReq == true ? (", " + newa) : newa)
      }
    }
    else {
      preva = newa;
    }
    return preva;
  }
  clearHTMLTags(input: any) {
    try {
      if ((input === null) || (input === ''))
        return false;
      else
        input = input.toString();

      return input.replace(/(<([^>]+)>)/ig, '');
    }
    catch
    {
      return input;
    }
  }
  checkAndOfEverything(value: any) {
    if (typeof value === 'string') {
      value = value.trim();
    }

    if (value !== null && value !== undefined && value !== "") {
      return true;
    }

    return false;
  };

  checkOrOfNothing(value: any) {
    if (typeof value === 'string') {
      value = value.trim();
    }

    if (value === null || value === undefined || value === "") {
      return true;
    }

    return false;
  };
  ascSortOrder(keyName: any) {
    return (a: any, b: any) => {
      let data = a[keyName];
      if (typeof (data) === 'boolean')
        return data?.toString().localeCompare(b[keyName].toString())

      else if (typeof (data) === 'string')
        return data?.localeCompare(b[keyName])

      else if (typeof (data) === 'number')
        return data > b[keyName] ? 1 : -1
      else
        return 0;
    }
  }
  descSortOrder(keyName: any) {
    return (a: any, b: any) => {
      let data = b[keyName]
      if (typeof (data) === 'boolean')
        return data?.toString().localeCompare(a[keyName].toString())

      else if (typeof (data) === 'string')
        return data?.localeCompare(a[keyName])

      else if (typeof (data) === 'number')
        return data < a[keyName] ? -1 : 1
      else
        return 0;
    }
  }

  getAvayaCallById(callId: number) {
    return this._APIService.post({ callId: callId }, Constants.search_API_URLS.getAvayaCallsById + callId)
  }
  updateLanguage(payload: any) {
    return this._APIService.post(payload, Constants.AGENT_DASHBOARD_URLS.updateLanguage)
  }
  getCustomUTCDate(startDate: string, endDate: string, formatString?: string) {
    if (formatString === null || formatString === undefined) {
      formatString = 'YYYY-MM-DD HH:mm:ss';
    }

    var fromDate = startDate + ' ' + Constants.REPORTTIME.StartTime;
    var toDate = endDate + ' ' + Constants.REPORTTIME.EndTime;
    fromDate = moment(fromDate).utc().format(formatString);
    toDate = moment(toDate).utc().format(formatString);
    return { fromDate: fromDate, toDate: toDate };
  };
  getCookieExpredDate(year: number) {
    var now = new Date();
    return new Date(now.getFullYear() + year, now.getMonth(), now.getDate());
  }
  /*
    * Service method to return currrent UTC time
    * @param1: format - date format
    */
  getUTC(format?: string) {
    if (format) {
      return moment.utc().format(format);
    }
    return moment.utc();
  };

  // convert the UTC date and time to local time
  getUTCToLocal(UTCdate: string, format?: string) {
    if (!UTCdate) {
      return "";
    }

    if (format) {
      return moment(UTCdate).local().format(format);
    }
    return moment(UTCdate).local();
  };
  // return the custom UTC date ranges to fetch the search reports
  getConvertedUTCDate(date: any, format?: string) {
    if (format) {
      format = 'YYYY-MM-DD HH:mm:ss';
    }

    let fromDate = date;
    fromDate = moment(fromDate).utc().format(format);
    return { fromDate: fromDate };
  };
  getUTCRangeDate() {
    let fromDate = moment().format('YYYY-MM-DD') + ' ' + Constants.REPORTTIME.StartTime;
    let toDate = moment().format('YYYY-MM-DD') + ' ' + Constants.REPORTTIME.EndTime;
    fromDate = moment(fromDate).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    toDate = moment(toDate).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    return { fromDate: fromDate, toDate: toDate };
  };
  convertToSecs(mins: number) {
    return mins * 60;
  }

  secondsDiff(datefrom:any) {
    var dateUpdated = moment(datefrom);
    var currentDate = moment.utc();

    //Difference in number of days
    return moment.duration(currentDate.diff(dateUpdated)).asSeconds();
  }
  /*
    * Service method logexception, to log exception happened in client
    * @param1: exceptionData - object that will have exception details
    */
  logException(exceptionData: any) {
    //TODO::switchOffLogs
    //if (!Constants.APP_CONFIG.switchOffLogs) {
    exceptionData.isServer = 0;
    exceptionData.userId = this._localCookies.get(Constants.APPCOOKIES.CCC_USERID);
    exceptionData.elevatorId = this._localCookies.get(Constants.APPCONSTANTS.lastElevatorId) == null ? this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID) : this._localCookies.get(Constants.APPCONSTANTS.lastElevatorId);
    exceptionData.incidentId = (exceptionData.incidentId === null || exceptionData.incidentId === undefined) ? this._localCookies.get(Constants.APPCOOKIES.CCC_INCIDENTID) : exceptionData.incidentId;

    var stringConstructor = "test".constructor;
    if (exceptionData.exceptionDetails !== undefined && exceptionData.exceptionDetails !== null) {
      if (exceptionData.exceptionDetails.constructor != stringConstructor) {
        exceptionData.exceptionDetails = JSON.stringify(exceptionData.exceptionDetails);
      }
    }

    return this._APIService.post(exceptionData, Constants.elevator_call_URLS.addException);
    //}
  };

  /*
  * Service method logMessage, to log messages. This will help to troubleshoot issues
  * @param1: message - object that will have message information
  */
  logMessage(message: any) {
    //TODO::switchOffLogs
    //if (!APP_CONFIG.switchOffLogs) {
    message.userId = this._localCookies.get(Constants.APPCOOKIES.CCC_USERID);
    message.elevatorId = this._localCookies.get('lastElevatorId') == null ? this._localCookies.get('CCApp-elevatorID') : this._localCookies.get('lastElevatorId');
    message.incidentId = (message.incidentId === null || message.incidentId === undefined) ? this._localCookies.get('CCApp-incidentID') : message.incidentId;
    message.isMessage = 1;
    message.isServer = 0;
    return this._APIService.post(message, Constants.elevator_call_URLS.addMessage);
    //}
  };

  userLoginCookiesSet(result: any) {
    // this will set the expiration to 1 day token validation
    var exp = Constants.GetCookieExpredDate(1);
    //Making that user is not on call
    this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, "0");
    this._localDataService.ecd.currentUser = result.user;


    if (this.router.url.indexOf('/avaya-') >= 0 || this.router.url.toLowerCase().indexOf('/otislinepbx') >= 0) {
      result.user.usertype = 'avaya';
      localStorage.setItem('userType', 'avaya');

      this._localCookies.set(Constants.APPCOOKIES.CCC_LOGGEDTYPE, '' + (result.user.workerId == null ? result.user.userID : result.user.workerId), { expires: exp });
    }
    else {
      result.user.usertype = 'ccc';
      localStorage.setItem('userType', 'ccc');
      if (this._localCookies.get(Constants.APPCOOKIES.CCC_LOGGEDTYPE) != undefined) {
        this._localCookies.delete(Constants.APPCOOKIES.CCC_LOGGEDTYPE);
      }
    }

    if (result.user.roleId == "4" || result.user.roleId == "5") {

      this._localCookies.set(Constants.APPCOOKIES.AVAYA_USERID, result.user.workerId, { expires: exp });
      this._localCookies.set(Constants.APPCOOKIES.AVAYA_EMAILID, result.user.emailId, { expires: exp });

      this._localCookies.set(Constants.APPCOOKIES.AVAYA_SCREENPOP_PAGE, result.user.countryShortName + '_' + result.user.languageShortName + '_avaya_elevator_call_details.json', {
        expires: exp
      });

      this._localCookies.set(Constants.APPCOOKIES.AVAYA_USERNAME, result.user.name, { expires: exp });
      this._localCookies.set(Constants.APPCOOKIES.AVAYA_LANGUAGEID, result.user.languageId, { expires: exp });
      this._localCookies.set(Constants.APPCOOKIES.AVAYA_COUNTRYID, result.user.countryId, { expires: exp });
      this._localCookies.set(Constants.APPCOOKIES.AVAYA_COUNTRY_SHORTNAME, result.user.countryShortName, { expires: exp });
    }

    this._localCookies.set(Constants.APPCOOKIES.CCC_TOKEN, result.accToken, { expires: exp });
    this._localCookies.set(Constants.APPCOOKIES.CCC_COUNTRYID, result.user.countryId, { expires: exp });
    this._localCookies.set(Constants.APPCOOKIES.CCC_EMAILID, result.user.emailId, { expires: exp });
    this._localCookies.set(Constants.APPCOOKIES.CCC_SID, result.user.sId, { expires: exp });
    this._localCookies.set(Constants.APPCOOKIES.CCC_USERID, result.user.userID, { expires: exp });
    this._localCookies.set(Constants.APPCOOKIES.CCC_ROLEID, result.user.roleId, { expires: exp });
    this._localCookies.set(Constants.APPCOOKIES.CCC_ELEVATORID, (result.user.elevatorId == null ? "" : result.user.elevatorId), { expires: exp });
    this._localDataService.ecd.countryConfig = { "countryconfigId": (result.user.countryConfigurationId == null ? 0 : result.user.countryConfigurationId), "enableDataTracks": (result.user.enableDataTracks == null ? "true" : result.user.enableDataTracks + ""), "enableNotAvailableReason": (result.user.enableNotAvailableReason == null ? "true" : result.user.enableNotAvailableReason + ""), "enableCallDispo": (result.user.enableCallDispo == null ? "true" : result.user.enableCallDispo + "") };

    let appConfg = Constants.APP_CONFIG;
    let usrStatus = Constants.USER_CURRENT_STATUS;

    this._localDataService.ecd.languageId = result.user.languageId;
    this._localDataService.ecd.languageShortName = result.user.languageShortName;
    this._localDataService.ecd.dataRetension = result.user.days;

    if (result.config != null) {
      usrStatus[0].sId = result.config.appConfig.idleSid;
      usrStatus[2].sId = result.config.appConfig.busySid;
      usrStatus[2].display = false;
      usrStatus[3].sId = result.config.appConfig.offlineSid;

      //binding SID data to constants user status
      Constants.USER_CURRENT_STATUS = usrStatus;
      //Modify app config
      appConfg.busySid = result.config.appConfig.busySid;
      appConfg.deleteSid = result.config.appConfig.deleteSid;
      appConfg.offlineSid = result.config.appConfig.offlineSid;
      appConfg.reservSid = result.config.appConfig.reservSid;

      appConfg.audioCodec = result.config.appConfig.audioCodec == null ? 'pcmu' : result.config.appConfig.audioCodec;
      appConfg.videoCodec = result.config.appConfig.videoCodec == null ? 'H264' : result.config.appConfig.videoCodec;
      appConfg.switchOffLogs = result.config.appConfig.switchOffLogs;
    }

    appConfg.isOnlyAudio = !result.user.video;

    //binding APP_CONFIG data to constants user App CONFIG
    Constants.APP_CONFIG = appConfg;
    if (result.user.activityStatusId != undefined) {
      this._localDataService.ecd.statusId = result.user.activityStatusId;
    }
    this._localDataService.ecd.selectedCountryId = parseInt(result.user.countryId);
    this._localDataService.ecd.selectedCountryShortName = result.user.countryShortName;

    this._localDataService.ecd.dateFormat = result.user.dateFormat;
    //this.$emit("changeCountry", this._localDataService.ecd.selectedCountryId);
    this._localDataService.ecd.selectedCountryName = this._localDataService.ecd.currentUser.countryName;
    this._localDataService.ecd.appData = {
      workers: {}
    };
    this._localDataService.ecd.appData.workers.identityToken = result.token;
    this._localDataService.ecd.appData.workers.workerToken = result.workerToken;
    this._localDataService.ecd.appData.menuHtml = result.menu;
    this._localDataService.ecd.appData.unmenuHtml = result.unmenu;
    this._localDataService.ecd.appData.linkMenuHtml = result.linkMenu;
    this._localDataService.ecd.notAvailableReason = {
      items: result.notAvailableReason,
      isAllDisabled: () => {
        let list = result.notAvailableReason.filter((element: any) => {
          return element.enabled == true;
        });
        return list.length <= 0;
      }
    };

    //this.shutdownReasonArry = result.shutdownReson;
    this._localDataService.ecd.questionOriginalText = result.questionText;

    //Assign countries
    //SELECTED_COUNTRY = result.selectedCountries;
    this._localDataService.ecd.SELECTED_COUNTRY = result.selectedCountries;
    this._localDataService.ecd.countryList = result.selectedCountries;
    this._localDataService.ecd.langaugeSkills = result.languageSkills;
  }
}
